import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Wrapper = styled.div`
  &.css-sticky {
    position: sticky;
    top: ${props => props.top}px;

    &:before,
    &:after {
      content: '';
      display: table;
    }
  }

  &.fixed {
    position: fixed;
    top: ${props => props.top}px;
  }

  &.fixed-bottom {
    position: absolute;
    top: ${props => props.marginTop}px;
  }
`

/**
 * This component is a wrapper that will make a component sticky so that it remains on the screen as the user
 * scrolls vertically.
 *
 * Usage notes:
 *  This component's parent must have position: relative;
 */

class StickyElem extends React.Component {
  render() {
    const cssClass = classNames({
      'css-sticky': !this.props.disableStickiness
    })

    return (
      <Wrapper
        className={cssClass}
        top={this.props.stickyThresholdTop}
        marginTop={this.props.stickyThresholdTop || 0}
      >
        {this.props.children}
      </Wrapper>
    )
  }
}

StickyElem.defaultProps = {
  stickyThresholdTop: 20,
  disableStickiness: false
}

StickyElem.propTypes = {
  // Timestamp of last time listings updated
  listingsLastUpdateTime: PropTypes.number,

  // Pixel offset from top of viewport when user scrolls past top of element's original position
  stickyThresholdTop: PropTypes.number,

  // Disable sticky positioning so it behaves like a normal element
  disableStickiness: PropTypes.bool,

  children: PropTypes.node
}

export { StickyElem }
